
















































import { Component, Vue } from 'vue-property-decorator';
import SideModalHeader from '@/components/SideModalHeader/SideModalHeader.vue';
import FlexButton from '@/components/FlexButton/FlexButton.vue';
import TextInput from '@/components/TextInput/TextInput.vue';
import eventBus from '@/utils/eventBus';
import BusinessService from '@/api/BusinessService';
import { formatString } from '@/utils/moneyTreatments';
import Typography from '@/components/atoms/Typography/Typography.vue';
@Component({
  components: {
    SideModalHeader,
    TextInput,
    FlexButton,
    Typography
  }
})
export default class SendCoinsModal extends Vue {
  coinsAmonunt: string = '';
  message: string = '';
  coinExchangeRatio: number = 0;
  service: BusinessService = new BusinessService();
  formatString: (value: string) => string = formatString;

  created() {
    this.service.getCoinExchange().then(res => {
      this.coinExchangeRatio = res.data.coinExchangeRatio;
    });
  }

  assingCoinsAmout(value: string) {
    const valueWithoutNumbers = value.replace(/\D/g, '');

    this.coinsAmonunt = valueWithoutNumbers;
  }

  onlyNumber(event: KeyboardEvent) {
    if (isNaN(Number(event.key))) {
      event.preventDefault();
    }
  }

  sendCoin() {
    eventBus.$emit('sendCoin', {
      coins: this.coinsAmonunt,
      message: this.message,
      money: this.getAmountDolar,
      placeholder: this.placeholderAmountDolar
    });
  }

  get placeholderAmountDolar() {
    const amount: number = Number(this.getAmountDolar);
    return (Math.floor(amount * 100) / 100)
      .toString()
      .replace(/\d(?=(\d{3})+\.)/g, '$&,');
  }

  get getAmountDolar() {
    const result = Number(this.coinsAmonunt) * this.coinExchangeRatio;
    return result.toFixed(4).replace(/\d(?=(\d{3})+\.)/g, '$&');
  }

  get getIsValid() {
    return (
      this.coinsAmonunt.length > 0 &&
      parseInt(this.coinsAmonunt) > 0 &&
      this.coinExchangeRatio
    );
  }

  get businessCurrency() {
    return this.$store.getters['internationalization/getCountrySettings']
      .currencySymbol;
  }
}
